<app-header></app-header>

@if (persistentError$ | async; as persistentError) {
  <app-persistent-error
    [title]="persistentError.title"
    [body]="persistentError.body"
  ></app-persistent-error>
}

<div class="toast-container position-fixed end-0 p-1">
  <app-toast></app-toast>
</div>

<app-title [questionnaire]="questionnaire$ | async"></app-title>
<router-outlet></router-outlet>
